/* Como */

jQuery.noConflict();

/**
 * Remove the URL hash without changing the scroll position.
 */
function removeHash() {
	var cleanURL = window.location.pathname + window.location.search;

	if (window.history && window.history.replaceState) {
		window.history.replaceState(window.history.state, document.title, cleanURL);
		return;
	}

	var scrollV = document.documentElement.scrollTop || document.body.scrollTop;
	var scrollH = document.documentElement.scrollLeft || document.body.scrollLeft;

	window.location.hash = '';
	window.scrollTo(scrollH, scrollV);
}

/**
 * Decode a URL component without allowing malformed values to throw.
 */
function safeDecodeURIComponent(value) {
	try {
		return decodeURIComponent(value);
	} catch (error) {
		return value;
	}
}

/**
 * Resolve a URL using the browser's native anchor parser.
 */
function parseURL(href) {
	var parser = document.createElement('a');

	parser.href = href || window.location.href;

	return parser;
}

/**
 * Extract the intended anchor ID from a hash or path-style URL.
 */
function getAnchorIdFromHref(href) {
	if (!href || href === '#') {
		return '';
	}

	var hashIndex = href.indexOf('#');
	var anchorId = '';

	if (hashIndex > -1) {
		anchorId = href.substring(hashIndex + 1);
	} else {
		var parsedURL = parseURL(href);
		var parsedOrigin = parsedURL.protocol + '//' + parsedURL.host;
		var currentOrigin = window.location.protocol + '//' + window.location.host;

		if (parsedURL.host && parsedOrigin !== currentOrigin) {
			return '';
		}

		var pathParts = parsedURL.pathname.split('/').filter(function(part) {
			return part !== '';
		});

		anchorId = pathParts.length ? pathParts[pathParts.length - 1] : '';
	}

	anchorId = safeDecodeURIComponent(anchorId);
	anchorId = anchorId.replace(/^\/?dev\//, '').replace(/^#/, '');

	return anchorId;
}

/**
 * Safely get an element by ID as a jQuery object.
 */
function getAnchorById(anchorId) {
	anchorId = safeDecodeURIComponent(String(anchorId || ''));
	anchorId = anchorId.replace(/^\/?dev\//, '').replace(/^#/, '');

	return anchorId ? jQuery(document.getElementById(anchorId)) : jQuery();
}

/**
 * Return the scroll-link wrapper.
 */
function getScrollLinkContainer($anchor) {
	if (!$anchor || !$anchor.length) {
		return jQuery();
	}

	return $anchor.hasClass('scroll-link')
		? $anchor
		: $anchor.closest('.scroll-link');
}

/**
 * Read numeric utility classes such as scrollto-80 and scrolldelay-500.
 */
function getNumericClassValue($element, prefix, fallback) {
	if (!$element || !$element.length) {
		return fallback;
	}

	var className = $element.attr('class') || '';
	var classes = className.split(/\s+/);
	var matcher = new RegExp('^' + prefix + '-(\\d+)$');
	var value = fallback;

	classes.some(function(classItem) {
		var match = classItem.match(matcher);

		if (match) {
			value = parseInt(match[1], 10);
			return true;
		}

		return false;
	});

	return value;
}

/**
 * Use the optional easing plugin when available.
 */
function getScrollEasing() {
	if (
		jQuery.easing &&
		typeof jQuery.easing.easeInOutExpo === 'function'
	) {
		return 'easeInOutExpo';
	}

	return 'swing';
}

/**
 * Build the pretty section URL used by updateURL links.
 */
function buildSectionURL(anchorId) {
	var rawPermalink =
		jQuery('body').data('page-permalink') ||
		(window.location.pathname + window.location.search);

	var parsedPermalink = parseURL(String(rawPermalink || '/'));
	var basePath = (parsedPermalink.pathname || '/').replace(/\/+$/, '');
	var query = parsedPermalink.search || '';

	return (basePath || '') + '/' + encodeURIComponent(anchorId) + '/' + query;
}

/**
 * Scroll to an anchor.
 */
function scrollToAnchor($anchor, scrollto, scrollDelay) {
	if (!$anchor || !$anchor.length) {
		return false;
	}

	var href = $anchor.attr('href');

	if (!href) {
		return false;
	}

	var anchorId = getAnchorIdFromHref(href);
	var $targetAnchor = getAnchorById(anchorId);

	if (!$targetAnchor.length) {
		window.location.href = href;
		return false;
	}

	var $scrollLinkContainer = getScrollLinkContainer($anchor);
	var updateURL = $scrollLinkContainer.hasClass('updateURL');
	var updateNav = $scrollLinkContainer.hasClass('updateNav');

	scrollto = typeof scrollto === 'number' ? scrollto : 50;
	scrollDelay = typeof scrollDelay === 'number' ? scrollDelay : 1000;

	scrollto = getNumericClassValue(
		$scrollLinkContainer,
		'scrollto',
		scrollto
	);

	scrollDelay = getNumericClassValue(
		$scrollLinkContainer,
		'scrolldelay',
		scrollDelay
	);

	if (updateNav) {
		jQuery('.menu-item').removeClass('active-menu-item');

		jQuery('.menu-item').filter(function() {
			return jQuery(this).hasClass(anchorId);
		}).addClass('active-menu-item');
	}

	if (updateURL && window.history && window.history.pushState) {
		window.history.pushState(
			null,
			document.title,
			buildSectionURL(anchorId)
		);
	} else {
		removeHash();
	}

	$targetAnchor.addClass('active-anchor');

	jQuery('html, body').stop(true).animate({
		scrollTop: Math.max(
			0,
			$targetAnchor.offset().top - scrollto
		)
	}, scrollDelay, getScrollEasing());

	return true;
}

/**
 * Determine whether a scroll link points to an anchor on this page.
 */
function isAnchorOnPage($scrollLink) {
	if (!$scrollLink || !$scrollLink.length) {
		return false;
	}

	var anchorId = getAnchorIdFromHref(
		$scrollLink.attr('href')
	);

	return getAnchorById(anchorId).length > 0;
}

/**
 * Detect IE / legacy Edge.
 */
function IEdetection() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf('MSIE ');
	var trident = ua.indexOf('Trident/');
	var edge = ua.indexOf('Edge/');

	if (msie > 0) {
		return 'IE-OLD';
	}

	if (trident > 0) {
		return 'IE';
	}

	if (edge > 0) {
		return 'EDGE';
	}

	return 'NOT-IE';
}

/**
 * Add browser classes to body.
 */
function browserDetect($) {
	var browser = (function(agent) {
		switch (true) {
			case agent.indexOf('edge') > -1:
				return 'ms-edge-edge-html';

			case agent.indexOf('edg') > -1:
				return 'ms-edge-chromium';

			case agent.indexOf('opr') > -1 && !!window.opr:
				return 'opera';

			case agent.indexOf('chrome') > -1 && !!window.chrome:
				return 'chrome';

			case agent.indexOf('trident') > -1:
				return 'internet-explorer';

			case agent.indexOf('firefox') > -1:
				return 'firefox';

			case agent.indexOf('safari') > -1:
				return 'safari';

			default:
				return 'other';
		}
	})(window.navigator.userAgent.toLowerCase());

	$('body').addClass(browser);

	var iOS =
		!!navigator.platform &&
		/iPad|iPhone|iPod/.test(navigator.platform);

	if (iOS === true) {
		$('body').addClass('ios');
	}

	var ie = IEdetection();

	if (ie === 'IE' || ie === 'IE-OLD') {
		$('body').addClass('ie');

		if (ie === 'IE-OLD') {
			$('body').addClass('ie-old');
		} else {
			$('body').addClass('ie-11');
		}
	} else if (ie === 'EDGE') {
		$('body').addClass('ie-edge');
	} else {
		$('body').addClass('not-ie');
	}
}

/**
 * Add accessibility helper links and text.
 */
function accessibilityLinks($) {
	$('section').each(function() {
		var $section = $(this);
		var $nextSection = $section.next('section');
		var nextID = $nextSection.attr('id');

		if (
			$nextSection.length &&
			nextID &&
			!$section.children(
				'.skip-section[href="#' + nextID + '"]'
			).length
		) {
			$('<a>', {
				'class':
					'skip-link skip-section screenreader-text sr-only',
				href: '#' + nextID,
				'aria-label': 'Skip to Next Section',
				text: 'Skip to Next Section'
			}).prependTo($section);
		}
	});

	$('a[target="_blank"]').each(function() {
		var $link = $(this);
		var href = $link.attr('href');

		if (
			!href ||
			$link.children('.como-link-notice').length
		) {
			return;
		}

		var parsedLink = parseURL(href);
		var extension = (
			parsedLink.pathname || ''
		).split('.').pop().toLowerCase();

		var notice = '(opens in a new tab)';

		if (extension === 'pdf') {
			notice = '(opens/downloads PDF file)';
		} else if (
			extension === 'doc' ||
			extension === 'docx'
		) {
			notice = '(opens/downloads Word document)';
		} else if (
			extension === 'ppt' ||
			extension === 'pptx'
		) {
			notice = '(opens/downloads PowerPoint file)';
		}

		$('<span>', {
			'class':
				'como-link-notice screenreader-text sr-only',
			text: notice
		}).appendTo($link);
	});
}

/**
 * Miscellaneous mobile adjustments.
 */
function comoMobileBehavior() {
	'use strict';

	var windowwidth = jQuery(window).width();

	if (windowwidth > 991) {
		jQuery('.hoverable .navbar-nav')
			.addClass('hover-menu');

		jQuery('.hoverable .navbar-nav .dropdown')
			.addClass('hover-menu')
			.removeClass('mobile-menu');

		jQuery('.mobile-toggle-link').each(function() {
			jQuery(this).addClass('scroll-link');
		});
	} else {
		jQuery('.hoverable .navbar-nav')
			.removeClass('hover-menu');

		jQuery('.hoverable .navbar-nav .dropdown')
			.removeClass('hover-menu')
			.addClass('mobile-menu');

		jQuery('.mobile-toggle-link').each(function() {
			jQuery(this).removeClass('scroll-link');
		});
	}
}

/**
 * Determine whether an element is in the viewport.
 */
function isInView(elem) {
	var $elem = jQuery(elem);

	if (!$elem.length || !$elem.is(':visible')) {
		return false;
	}

	var $window = jQuery(window);
	var viewportTop = $window.scrollTop();
	var viewportBottom = viewportTop + $window.height();
	var top = $elem.offset().top;
	var bottom = top + $elem.outerHeight();

	return bottom > viewportTop && top < viewportBottom;
}

/**
 * Accessible Menubar widget.
 */
function menubar(id, vmenu) {
	this.$id = jQuery(id);
	this.$rootItems = this.$id.children('.menu-item');
	this.$items = this.$id.find('.menu-item');
	this.$parents = this.$id.find('.menu-parent');
	this.$allItems = this.$parents.add(this.$items);
	this.$activeItem = null;
	this.vmenu = vmenu;
	this.bChildOpen = false;

	this.keys = {
		tab: 9,
		enter: 13,
		esc: 27,
		space: 32,
		left: 37,
		up: 38,
		right: 39,
		down: 40
	};

	this.bindHandlers();
}

menubar.prototype.bindHandlers = function() {
	var thisObj = this;

	this.$items.on('mouseenter', function() {
		jQuery(this)
			.addClass('menu-hover')
			.attr('aria-expanded', 'true');

		jQuery(this)
			.children('.dropdown-menu')
			.first()
			.addClass('show');

		return true;
	});

	this.$items.on('mouseout', function() {
		jQuery(this)
			.removeClass('menu-hover')
			.attr('aria-expanded', 'false');

		return true;
	});

	this.$parents.on('mouseenter', function(e) {
		return thisObj.handleMouseEnter(
			jQuery(this),
			e
		);
	});

	this.$parents.on('mouseleave', function(e) {
		return thisObj.handleMouseLeave(
			jQuery(this),
			e
		);
	});

	this.$allItems.on('click', function(e) {
		return thisObj.handleClick(
			jQuery(this),
			e
		);
	});

	this.$allItems.on('keydown', function(e) {
		return thisObj.handleKeyDown(
			jQuery(this),
			e
		);
	});

	this.$allItems.on('keypress', function(e) {
		return thisObj.handleKeyPress(
			jQuery(this),
			e
		);
	});

	this.$allItems.on('focus', function(e) {
		return thisObj.handleFocus(
			jQuery(this),
			e
		);
	});

	this.$allItems.on('blur', function(e) {
		return thisObj.handleBlur(
			jQuery(this),
			e
		);
	});

	jQuery(document).on('click', function(e) {
		return thisObj.handleDocumentClick(e);
	});
};

menubar.prototype.handleMouseEnter = function($item) {
	$item.addClass('menu-hover');

	if ($item.attr('aria-haspopup') === 'true') {
		if (!$item.closest('ul').hasClass('root-level')) {
			var $menu = $item.closest('ul');

			$menu
				.children('.dropdown')
				.not($item)
				.children('.dropdown-menu')
				.removeClass('show')
				.attr('aria-hidden', 'true');
		}

		$item
			.children('.dropdown-menu')
			.addClass('show')
			.attr('aria-hidden', 'false');

		this.bChildOpen = true;
	}

	return true;

};

menubar.prototype.handleMouseOut = function($item) {
	$item.removeClass('menu-hover');

	return true;
};

menubar.prototype.handleMouseLeave = function($menu) {
	var $active = $menu.find('.menu-focus');

	$active = $active.add(
		$menu.find('.menu-focus')
	);

	if ($menu.parent().hasClass('root-level')) {
		$menu.removeClass('menu-hover');

		if ($active.length > 0) {
			this.bChildOpen = false;
			$active.removeClass('menu-focus');
			this.$activeItem = $menu;
			$menu.focus();
		}

		setTimeout(function() {
			$menu
				.find('.dropdown-menu')
				.removeClass('show')
				.attr('aria-hidden', 'true');
		}, 10);

		return true;
	}

	if ($menu.hasClass('dropdown')) {
		$menu
			.find('.dropdown-menu')
			.removeClass('show')
			.attr('aria-hidden', 'true');
	}

	return true;
};

menubar.prototype.handleClick = function($item, e) {
	var $link = $item.children('a').first();
	var $submenu = $item.children('.dropdown-menu').first();

	var isScrollLink =
		$item.hasClass('scroll-link') ||
		$link.hasClass('scroll-link');

	var hasSubmenu =
		$submenu.length > 0 ||
		$item.hasClass('menu-parent') ||
		$item.attr('aria-haspopup') === 'true';

	if (isScrollLink) {
		e.preventDefault();
		e.stopPropagation();

		scrollToAnchor($link, 50, 1000);

		return false;
	}

	if (
		hasSubmenu &&
		!$item.hasClass('follow-link') &&
		!$link.hasClass('follow-link')
	) {
		e.preventDefault();
		e.stopPropagation();

		var shouldOpen = !$submenu.hasClass('show');
		var $siblings = $item.siblings('.menu-item');

		$siblings
			.removeClass('menu-hover menu-focus')
			.children('.dropdown-menu')
			.removeClass('show')
			.attr('aria-hidden', 'true');

		$siblings
			.children('a')
			.attr('aria-expanded', 'false');

		$submenu
			.toggleClass('show', shouldOpen)
			.attr(
				'aria-hidden',
				shouldOpen ? 'false' : 'true'
			);

		$link.attr(
			'aria-expanded',
			shouldOpen ? 'true' : 'false'
		);

		$item.toggleClass(
			'menu-hover',
			shouldOpen
		);

		this.bChildOpen = shouldOpen;

		return false;
	}

	this.$allItems.removeClass(
		'menu-hover menu-focus'
	);

	this.$id
		.find('.dropdown-menu')
		.not('.root-level')
		.removeClass('show')
		.attr('aria-hidden', 'true');

	this.bChildOpen = false;

	return true;
};

menubar.prototype.handleFocus = function($item) {
	if (this.$activeItem === null) {
		this.$activeItem = $item;
	} else if ($item[0] !== this.$activeItem[0]) {
		return true;
	}

	var $parentItems = this.$activeItem
		.parentsUntil('div')
		.filter('.menu-item');

	this.$allItems.removeClass('menu-focus');
	this.$activeItem.addClass('menu-focus');
	$parentItems.addClass('menu-focus');

	if (this.vmenu === true) {
		if (this.bChildOpen === true) {
			var $itemUL = $item.parent();

			if (
				$itemUL.is('.root-level') &&
				$item.attr('aria-haspopup') === 'true'
			) {
				$item
					.children('.dropdown-menu')
					.addClass('show')
					.attr('aria-hidden', 'false');
			}
		} else {
			this.vmenu = false;
		}
	}

	return true;
};

menubar.prototype.handleBlur = function($item) {
	$item.removeClass('menu-focus');

	return true;
};

menubar.prototype.handleKeyDown = function($item, e) {
	if (e.altKey || e.ctrlKey) {
		return true;
	}

	var $itemUL = $item.parent();

	switch (e.keyCode) {
		case this.keys.tab:
			this.$id
				.find('.dropdown-menu')
				.removeClass('show')
				.attr('aria-hidden', 'true');

			this.$allItems.removeClass('menu-focus');
			this.$activeItem = null;
			this.bChildOpen = false;

			break;

		case this.keys.esc:
			if ($itemUL.is('.root-level')) {
				$item
					.children('.dropdown-menu')
					.first()
					.removeClass('show')
					.attr('aria-hidden', 'true');
			} else {
				this.$activeItem = $itemUL.parent();
				this.bChildOpen = false;
				this.$activeItem.focus();

				$itemUL
					.removeClass('show')
					.attr('aria-hidden', 'true');
			}

			e.stopPropagation();

			return false;

		case this.keys.enter:
		case this.keys.space:
			if (
				$item.hasClass('scroll-link') ||
				$item
					.children('a')
					.first()
					.hasClass('scroll-link')
			) {
				e.preventDefault();

				var $anchorLink = $item
					.children('a')
					.first();

				scrollToAnchor(
					$anchorLink,
					50,
					1000
				);

				return false;
			}

			if (
				$item.hasClass('follow-link') ||
				!$item.hasClass('menu-parent')
			) {
				var $itemLink = $item
					.children('a')
					.first();

				var target = $itemLink.attr('target');

				if (target === '_blank') {
					$itemLink.trigger('click');
				} else {
					window.location =
						$itemLink.attr('href');
				}

				return false;
			}

			if ($itemUL.is('.root-level')) {
				$item
					.children('.dropdown-menu')
					.first()
					.addClass('show')
					.attr('aria-hidden', 'false');

				this.bChildOpen = true;
			} else {
				this.$allItems.removeClass(
					'menu-hover menu-focus'
				);

				this.$id
					.find('.dropdown-menu')
					.not('.root-level')
					.removeClass('show')
					.attr('aria-hidden', 'true');

				this.$activeItem = null;
			}

			e.stopPropagation();

			return false;

		case this.keys.left:
			if (
				this.vmenu === true &&
				$itemUL.is('.root-level')
			) {
				this.$activeItem =
					this.moveUp($item);
			} else {
				this.$activeItem =
					this.moveToPrevious($item);
			}

			if (
				this.$activeItem &&
				this.$activeItem.length
			) {
				this.$activeItem.focus();
			}

			e.stopPropagation();

			return false;

		case this.keys.right:
			if (
				this.vmenu === true &&
				$itemUL.is('.root-level')
			) {
				this.$activeItem =
					this.moveDown($item);
			} else {
				this.$activeItem =
					this.moveToNext($item);

				if (
					this.$activeItem &&
					this.$activeItem.length
				) {
					var $thisParent =
						this.$activeItem.parents(
							'.dropdown-menu'
						);

					var thisGrandParent =
						$thisParent
							.parents('.dropdown-menu')
							.parent('.dropdown');

					jQuery(
						'.navbar-nav > .menu-item'
					)
						.not(thisGrandParent)
						.find('.dropdown-menu')
						.removeClass('show');

					jQuery(
						'.menu-focus > .dropdown-menu'
					).addClass('show');
				}
			}

			if (
				this.$activeItem &&
				this.$activeItem.length
			) {
				this.$activeItem.focus();
			}

			e.stopPropagation();

			return false;

		case this.keys.up:
			if (
				this.vmenu === true &&
				$itemUL.is('.root-level')
			) {
				this.$activeItem =
					this.moveToPrevious($item);
			} else {
				this.$activeItem =
					this.moveUp($item);
			}

			if (
				this.$activeItem &&
				this.$activeItem.length
			) {
				this.$activeItem.focus();
			}

			e.stopPropagation();

			return false;

		case this.keys.down:
			if (
				this.vmenu === true &&
				$itemUL.is('.root-level')
			) {
				this.$activeItem =
					this.moveToNext($item);
			} else {
				this.$activeItem =
					this.moveDown($item);
			}

			if (
				this.$activeItem &&
				this.$activeItem.length
			) {
				this.$activeItem.focus();
			}

			e.stopPropagation();

			return false;

		default:
			return true;
	}

	return true;
};

menubar.prototype.moveToNext = function($item) {
	var $itemUL = $item.parent();

	var $menuItems = $itemUL
		.children('.menu-item')
		.not('.separator, .seperator');

	var menuNum = $menuItems.length;
	var menuIndex = $menuItems.index($item);
	var $newItem = null;
	var $childMenu;
	var $parentMenus;
	var $rootItem;

	if ($itemUL.is('.root-level')) {
		if (menuIndex < menuNum - 1) {
			$newItem = $menuItems.eq(menuIndex + 1);
		} else {
			$newItem = $menuItems.first();
		}

		if ($item.attr('aria-haspopup') === 'true') {
			$childMenu = $item
				.children('.dropdown-menu')
				.first();

			if (
				$childMenu.attr('aria-hidden') ===
				'false'
			) {
				$childMenu
					.removeClass('show')
					.attr('aria-hidden', 'true');

				this.bChildOpen = true;
			}
		}

		$item.removeClass('menu-focus');

		if (
			$newItem.attr('aria-haspopup') === 'true' &&
			this.bChildOpen === true
		) {
			$childMenu = $newItem
				.children('.dropdown-menu')
				.first();

			$childMenu
				.addClass('show')
				.attr('aria-hidden', 'false');

			if (!this.vmenu) {
				$newItem = $childMenu
					.find('.menu-item')
					.not('.separator, .seperator')
					.first();
			}
		}
	} else {
		if ($item.attr('aria-haspopup') === 'true') {
			$childMenu = $item
				.children('.dropdown-menu')
				.first();

			$newItem = $childMenu
				.find('.menu-item')
				.not('.separator, .seperator')
				.first();

			$childMenu
				.addClass('show')
				.attr('aria-hidden', 'false');

			this.bChildOpen = true;
		} else {
			if (this.vmenu === true) {
				return $item;
			}

			$parentMenus = $item
				.parentsUntil('div')
				.filter('.dropdown-menu')
				.not('.root-level');

			$parentMenus
				.removeClass('show')
				.attr('aria-hidden', 'true');

			$parentMenus
				.find('.menu-item')
				.removeClass('menu-focus');

			$parentMenus
				.last()
				.parent()
				.removeClass('menu-focus');

			$rootItem = $parentMenus
				.last()
				.parent();

			menuIndex = this.$rootItems.index(
				$rootItem
			);

			if (
				menuIndex <
				this.$rootItems.length - 1
			) {
				$newItem = $rootItem.next();
			} else {
				$newItem = this.$rootItems.first();
			}

			if (
				$newItem.attr('aria-haspopup') ===
				'true'
			) {
				$childMenu = $newItem
					.children('.dropdown-menu')
					.first();

				$newItem = $childMenu
					.find('.menu-item')
					.not('.separator, .seperator')
					.first();

				$childMenu
					.addClass('show')
					.attr('aria-hidden', 'false');

				this.bChildOpen = true;
			}
		}
	}

	return $newItem || $item;
};

menubar.prototype.moveToPrevious = function($item) {
	var $itemUL = $item.parent();

	var $menuItems = $itemUL
		.children('.menu-item')
		.not('.separator, .seperator');

	var menuNum = $menuItems.length;
	var menuIndex = $menuItems.index($item);
	var $newItem = null;
	var $childMenu;

	if ($itemUL.is('.root-level')) {
		if (menuIndex > 0) {
			$newItem = $menuItems.eq(menuIndex - 1);
		} else {
			$newItem = $menuItems.last();
		}

		if ($item.attr('aria-haspopup') === 'true') {
			$childMenu = $item
				.children('.dropdown-menu')
				.first();

			if (
				$childMenu.attr('aria-hidden') ===
				'false'
			) {
				$childMenu
					.removeClass('show')
					.attr('aria-hidden', 'true');

				this.bChildOpen = true;
			}
		}

		$item.removeClass('menu-focus');

		if (
			$newItem.attr('aria-haspopup') === 'true' &&
			this.bChildOpen === true
		) {
			$childMenu = $newItem
				.children('.dropdown-menu')
				.first();

			$childMenu
				.addClass('show')
				.attr('aria-hidden', 'false');

			if (!this.vmenu) {
				$newItem = $childMenu
					.find('.menu-item')
					.not('.separator, .seperator')
					.first();
			}
		}
	} else {
		var $parentLI = $itemUL.parent();
		var $parentUL = $parentLI.parent();

		if (
			this.vmenu === true ||
			!$parentUL.is('.root-level')
		) {
			$newItem = $itemUL.parent();

			$itemUL
				.removeClass('show')
				.attr('aria-hidden', 'true');

			$item.removeClass('menu-focus');

			if (this.vmenu === true) {
				this.bChildOpen = false;
			}
		} else {
			$itemUL
				.removeClass('show')
				.attr('aria-hidden', 'true');

			$item.removeClass('menu-focus');
			$parentLI.removeClass('menu-focus');

			menuIndex = this.$rootItems.index(
				$parentLI
			);

			if (menuIndex > 0) {
				$newItem = $parentLI.prev();
			} else {
				$newItem = this.$rootItems.last();
			}

			$newItem.addClass('menu-focus');

			if (
				$newItem.attr('aria-haspopup') ===
				'true'
			) {
				$childMenu = $newItem
					.children('.dropdown-menu')
					.first();

				$childMenu
					.addClass('show')
					.attr('aria-hidden', 'false');

				this.bChildOpen = true;

				$newItem = $childMenu
					.children('.menu-item')
					.first()
					.not('.separator, .seperator');
			}
		}
	}

	return $newItem || $item;
};

menubar.prototype.moveDown = function(
	$item,
	startChr
) {
	var $itemUL = $item.parent();

	var $menuItems = $itemUL
		.children('.menu-item')
		.not('.separator, .seperator');

	var menuNum = $menuItems.length;
	var menuIndex = $menuItems.index($item);
	var $newItem = null;
	var $newItemUL = null;

	if ($itemUL.is('.root-level')) {
		if (
			$item.attr('aria-haspopup') !== 'true'
		) {
			return $item;
		}

		$newItemUL = $item
			.children('.dropdown-menu')
			.first();

		$newItem = $newItemUL
			.find('.menu-item')
			.not('.separator, .seperator')
			.first();

		$newItemUL
			.addClass('show')
			.attr('aria-hidden', 'false');

		this.bChildOpen = true;

		return $newItem;
	}

	if (startChr) {
		var bMatch = false;
		var curNdx = menuIndex + 1;

		if (curNdx === menuNum) {
			curNdx = 0;
		}

		while (curNdx !== menuIndex) {
			var $currentLink = $menuItems
				.eq(curNdx)
				.find('a')
				.first();

			var linkText =
				$currentLink.text() || '';

			var titleChr = linkText.charAt(0);

			if (
				titleChr.toLowerCase() ===
				String(startChr).toLowerCase()
			) {
				bMatch = true;
				break;
			}

			curNdx = curNdx + 1;

			if (curNdx === menuNum) {
				curNdx = 0;
			}
		}

		if (bMatch === true) {
			$newItem = $menuItems.eq(curNdx);
			$item.removeClass('menu-focus');

			return $newItem;
		}

		return $item;
	}

	if (menuIndex < menuNum - 1) {
		$newItem = $menuItems.eq(menuIndex + 1);
	} else {
		$newItem = $menuItems.first();
	}

	$item.removeClass('menu-focus');

	return $newItem || $item;
};

menubar.prototype.moveUp = function($item) {
	var $itemUL = $item.parent();

	var $menuItems = $itemUL
		.children('.menu-item')
		.not('.separator, .seperator');

	var menuIndex = $menuItems.index($item);
	var $newItem = null;

	if ($itemUL.is('.root-level')) {
		return $item;
	}

	if (menuIndex > 0) {
		$newItem = $menuItems.eq(menuIndex - 1);
	} else {
		$newItem = $menuItems.last();
	}

	$item.removeClass('menu-focus');

	return $newItem || $item;
};

menubar.prototype.handleKeyPress = function(
	$item,
	e
) {
	if (e.altKey || e.ctrlKey || e.shiftKey) {
		return true;
	}

	switch (e.keyCode) {
		case this.keys.tab:
			return true;

		case this.keys.esc:
		case this.keys.enter:
		case this.keys.space:
		case this.keys.up:
		case this.keys.down:
		case this.keys.left:
		case this.keys.right:
			e.stopPropagation();

			return false;

		default:
			var chr = String.fromCharCode(e.which);

			this.$activeItem = this.moveDown(
				$item,
				chr
			);

			if (
				this.$activeItem &&
				this.$activeItem.length
			) {
				this.$activeItem.focus();
			}

			e.stopPropagation();

			return false;
	}
};

menubar.prototype.handleDocumentClick = function() {
	var $childMenus = this.$id
		.find('.dropdown-menu')
		.not('.root-level');

	$childMenus
		.removeClass('show')
		.attr('aria-hidden', 'true');

	this.$allItems.removeClass('menu-focus');
	this.$activeItem = null;

	return true;
};

/**
 * Enable tabbed accessible menu behavior.
 */
function enableTabbedAccessibleMenu($) {
	var $body = $('body');

	var submenuSelector =
		'.hover-menu .dropdown-menu .dropdown';

	$('.hover-menu .dropdown')
		.off('.comoHover')
		.on(
			'mouseenter.comoHover focusin.comoHover',
			function() {
				var $item = $(this);

				var $toggle = $item
					.children(
						'a[data-bs-toggle], .dropdown-toggle'
					)
					.first();

				var $menu = $item
					.children('.dropdown-menu')
					.first();

				$toggle
					.addClass('show')
					.attr('aria-expanded', 'true');

				$menu.addClass('show');
			}
		)
		.on(
			'mouseleave.comoHover focusout.comoHover',
			function(event) {
				if (
					event.relatedTarget &&
					$.contains(
						this,
						event.relatedTarget
					)
				) {
					return;
				}

				var $item = $(this);

				$item
					.children(
						'a[data-bs-toggle], .dropdown-toggle'
					)
					.first()
					.removeClass('show')
					.attr('aria-expanded', 'false');

				$item
					.children('.dropdown-menu')
					.first()
					.removeClass('show expand');

				$item.removeClass('sub-expand');
			}
		);

	$('.dropdown-menu')
		.off(
			'click.comoDropdownItem',
			'.dropdown-item'
		)
		.on(
			'click.comoDropdownItem',
			'.dropdown-item',
			function(event) {
				var $link = $(this);

				var $item = $link.closest(
					'.menu-item'
				);

				var $submenu = $item
					.children('.dropdown-menu')
					.first();

				if (
					$item.hasClass('scroll-link') ||
					$link.hasClass('scroll-link')
				) {
					event.preventDefault();

					if (isAnchorOnPage($link)) {
						scrollToAnchor(
							$link,
							50,
							1000
						);
					} else if ($link.attr('href')) {
						window.location.href =
							$link.attr('href');
					}

					return false;
				}

				if (
					$submenu.length &&
					!$link.hasClass('follow-link')
				) {
					event.preventDefault();
					event.stopPropagation();

					var shouldOpen =
						!$item.hasClass(
							'sub-expand'
						);

					$item.toggleClass(
						'sub-expand',
						shouldOpen
					);

					$link
						.toggleClass(
							'show',
							shouldOpen
						)
						.attr(
							'aria-expanded',
							shouldOpen
								? 'true'
								: 'false'
						);

					$submenu
						.toggleClass(
							'expand show',
							shouldOpen
						)
						.attr(
							'aria-hidden',
							shouldOpen
								? 'false'
								: 'true'
						);

					return false;
				}

				return true;
			}
		);

	$body
		.off('.comoSubmenu', submenuSelector)
		.on(
			'mouseenter.comoSubmenu focusin.comoSubmenu',
			submenuSelector,
			function() {
				var $item = $(this);

				var $toggle = $item
					.children('.dropdown-toggle')
					.first();

				var $submenu = $item
					.children('.dropdown-menu')
					.first();

				if (
					$('#mainNav.hoverable')
						.hasClass('hide-sub-onBlur')
				) {
					$(submenuSelector)
						.not($item)
						.removeClass('sub-expand')
						.children('.dropdown-menu')
						.removeClass('expand show')
						.attr(
							'aria-hidden',
							'true'
						);
				}

				$item.addClass('sub-expand');

				$toggle
					.addClass('show')
					.attr('aria-expanded', 'true');

				$submenu
					.addClass('expand show')
					.attr('aria-hidden', 'false');
			}
		)
		.on(
			'mouseleave.comoSubmenu focusout.comoSubmenu',
			submenuSelector,
			function(event) {
				if (
					event.relatedTarget &&
					$.contains(
						this,
						event.relatedTarget
					)
				) {
					return;
				}

				if (
					$('#mainNav.hoverable')
						.hasClass('hide-sub-onBlur')
				) {
					var $item = $(this);

					$item.removeClass(
						'sub-expand'
					);

					$item
						.children(
							'.dropdown-toggle'
						)
						.first()
						.removeClass('show')
						.attr(
							'aria-expanded',
							'false'
						);

					$item
						.children(
							'.dropdown-menu'
						)
						.first()
						.removeClass(
							'expand show'
						)
						.attr(
							'aria-hidden',
							'true'
						);
				}
			}
		);

	$body
		.off(
			'click.comoSubmenuToggle',
			'.dropdown-menu .dropdown > .dropdown-toggle'
		)
		.on(
			'click.comoSubmenuToggle',
			'.dropdown-menu .dropdown > .dropdown-toggle',
			function(event) {
				var $toggle = $(this);

				var $item = $toggle.parent(
					'.dropdown'
				);

				var $submenu = $item
					.children('.dropdown-menu')
					.first();

				if (
					!$submenu.length ||
					$toggle.hasClass('follow-link')
				) {
					return true;
				}

				event.preventDefault();
				event.stopPropagation();

				var shouldOpen =
					!$item.hasClass('sub-expand');

				$item.toggleClass(
					'sub-expand',
					shouldOpen
				);

				$toggle
					.toggleClass('show', shouldOpen)
					.attr(
						'aria-expanded',
						shouldOpen
							? 'true'
							: 'false'
					);

				$submenu
					.toggleClass(
						'expand show',
						shouldOpen
					)
					.attr(
						'aria-hidden',
						shouldOpen
							? 'false'
							: 'true'
					);

				return false;
			}
		);

	$body
		.off(
			'focusin.comoAccessibleMenu',
			'.hoverable .navbar-nav a'
		)
		.on(
			'focusin.comoAccessibleMenu',
			'.hoverable .navbar-nav a',
			function() {
				var $link = $(this);
				var $parents = $link.parents(
					'.dropdown'
				);

				$('.hoverable .navbar-nav .dropdown')
					.not($parents)
					.removeClass('sub-expand')
					.children('.dropdown-menu')
					.removeClass('expand show')
					.attr('aria-hidden', 'true');

				$('.hoverable .navbar-nav .dropdown')
					.not($parents)
					.children('.dropdown-toggle')
					.removeClass('show')
					.attr(
						'aria-expanded',
						'false'
					);

				$parents.each(function() {
					var $parent = $(this);

					$parent.addClass(
						'sub-expand'
					);

					$parent
						.children(
							'.dropdown-toggle'
						)
						.first()
						.addClass('show')
						.attr(
							'aria-expanded',
							'true'
						);

					$parent
						.children(
							'.dropdown-menu'
						)
						.first()
						.addClass(
							'expand show'
						)
						.attr(
							'aria-hidden',
							'false'
						);
				});
			}
		);
}

/**
 * Enable click dropdown behavior.
 */
function enableClickDropdowns($) {
	$('.dropdown-menu')
		.off(
			'click.comoClickDropdown',
			'.dropdown-toggle'
		)
		.on(
			'click.comoClickDropdown',
			'.dropdown-toggle',
			function(event) {
				var $toggle = $(this);

				var $parentItem = $toggle.parent(
					'.menu-item'
				);

				var $parentMenu = $parentItem.closest(
					'.dropdown-menu'
				);

				if ($toggle.hasClass('show')) {
					event.stopPropagation();
				}

				$parentMenu
					.children('.dropdown')
					.not($parentItem)
					.each(function() {
						$(this)
							.removeClass(
								'sub-expand'
							)
							.children(
								'.dropdown-toggle'
							)
							.removeClass('show')
							.attr(
								'aria-expanded',
								'false'
							);

						$(this)
							.children(
								'.dropdown-menu'
							)
							.removeClass(
								'show expand'
							)
							.attr(
								'aria-hidden',
								'true'
							);
					});
			}
		);
}

/**
 * Make Bootstrap dropdowns hoverable.
 */
function enableHoverMenu($) {
	$('.navbar .nav-item.hover-menu')
		.off('.comoMainHover')
		.on(
			'mouseenter.comoMainHover focusin.comoMainHover',
			function() {
				var $item = $(this);

				$item
					.children(
						'a[data-bs-toggle], .dropdown-toggle'
					)
					.first()
					.addClass('show')
					.attr('aria-expanded', 'true');

				$item
					.children('.dropdown-menu')
					.first()
					.addClass('show')
					.attr('aria-hidden', 'false');
			}
		)
		.on(
			'mouseleave.comoMainHover focusout.comoMainHover',
			function(event) {
				if (
					event.relatedTarget &&
					$.contains(
						this,
						event.relatedTarget
					)
				) {
					return;
				}

				var $item = $(this);

				$item
					.children(
						'a[data-bs-toggle], .dropdown-toggle'
					)
					.first()
					.removeClass('show')
					.attr('aria-expanded', 'false');

				$item
					.children('.dropdown-menu')
					.first()
					.removeClass('show')
					.attr('aria-hidden', 'true');
			}
		);
}

/**
 * Enable top-level menu links.
 */
function enableTopLevelMenuLinks($) {
	$('.hoverable .navbar-nav > .menu-item > a')
		.off('click.comoTopLevel')
		.on('click.comoTopLevel', function(event) {
			var $link = $(this);

			if (
				$link.hasClass('scroll-link') ||
				$link.parent().hasClass('scroll-link')
			) {
				return true;
			}

			if (
				!$link.hasClass('dropdown-toggle') ||
				$(window).width() <= 991
			) {
				return true;
			}

			var href = $link.attr('href');

			if (
				!href ||
				href === '#' ||
				/^javascript:/i.test(href)
			) {
				return true;
			}

			event.preventDefault();

			if ($link.attr('target') === '_blank') {
				window.open(
					href,
					'_blank',
					'noopener'
				);
			} else {
				window.location.href = href;
			}

			return false;
		});
}

/**
 * Modal adjustments.
 */
function modalAdjustments($) {
	$(document.body).on(
		'show.bs.modal',
		function() {
			$(window.document)
				.find('html')
				.addClass('no-scrollbar');
		}
	);

	$(document.body).on(
		'hide.bs.modal',
		function() {
			$(window.document)
				.find('html')
				.removeClass('no-scrollbar');
		}
	);

	$('body').on(
		'hidden.bs.modal',
		'.video-modal',
		function() {
			$('.video-modal')
				.find('video')
				.trigger('pause');
		}
	);
}

/**
 * Initialize nav based on accessibility class.
 */
function checkNavMenu($) {
	var $mainNav = $('#mainNav');
	var $navbarNav = $mainNav.find('.navbar-nav');

	if (!$navbarNav.length) {
		return;
	}

	if ($navbarNav.data('como-nav-initialized')) {
		return;
	}

	$navbarNav.data(
		'como-nav-initialized',
		true
	);

	if ($navbarNav.hasClass('accessible')) {
		new menubar(
			'#mainNav .navbar-nav',
			false
		);

		enableTopLevelMenuLinks($);
	} else if (
		$navbarNav.hasClass('tab-accessible')
	) {
		enableTabbedAccessibleMenu($);
		enableTopLevelMenuLinks($);
	} else {
		enableClickDropdowns($);
	}
}

/**
 * Register scroll links for URL updates.
 */
function registerScrollLinks($) {
	var navlist = [];

	$(
		'#mainNav .update-url-on-scroll .scroll-link'
	).each(function() {
		var $link = $(this)
			.children('a')
			.first();

		var anchorId = getAnchorIdFromHref(
			$link.attr('href')
		);

		var $target = getAnchorById(anchorId);

		if (
			$link.length &&
			anchorId &&
			$target.length
		) {
			navlist.push({
				anchor: $link,
				id: anchorId,
				target: $target
			});
		}
	});

	if (!navlist.length) {
		return;
	}

	var originalURL =
		window.location.pathname +
		window.location.search;

	var scheduled = false;

	var requestFrame =
		window.requestAnimationFrame ||
		function(callback) {
			return window.setTimeout(
				callback,
				16
			);
		};

	$(window)
		.off('scroll.comoURL')
		.on('scroll.comoURL', function() {
			if (scheduled) {
				return;
			}

			scheduled = true;

			requestFrame(function() {
				scheduled = false;

				if ($(window).scrollTop() > 100) {
					updateURLonScroll(
						$,
						navlist
					);
				} else if (
					window.history &&
					window.history.replaceState
				) {
					window.history.replaceState(
						null,
						document.title,
						originalURL
					);
				}
			});
		});
}

/**
 * Update the URL while scrolling.
 */
function updateURLonScroll($, navlist) {
	if (
		!window.history ||
		!window.history.replaceState ||
		!navlist ||
		!navlist.length
	) {
		return;
	}

	var currentScrollOffset =
		$(window).scrollTop() + 75;

	var activeItem = null;

	$.each(navlist, function(index, item) {
		if (
			!item.target ||
			!item.target.length
		) {
			return true;
		}

		if (
			item.target.offset().top <=
			currentScrollOffset
		) {
			activeItem = item;
			return true;
		}

		return false;
	});

	if (!activeItem) {
		return;
	}

	var newURL = buildSectionURL(
		activeItem.id
	);

	var currentURL =
		window.location.pathname +
		window.location.search;

	if (currentURL !== newURL) {
		window.history.replaceState(
			null,
			document.title,
			newURL
		);
	}
}

/**
 * Main theme behavior.
 */
(function($) {
	'use strict';

	$(function() {
		var $window = $(window);
		var $body = $('body');
		var $masthead = $('#masthead');
		var $contentWrap = $('#content-wrap');

		var scrollOffset = 50;
		var scrollDelay = 1000;

		var contentStart = $contentWrap.length
			? $contentWrap.offset().top
			: null;

		var framePending = false;

		var requestFrame =
			window.requestAnimationFrame ||
			function(callback) {
				return window.setTimeout(
					callback,
					16
				);
			};

		var animationNames = [
			'bounceIn',
			'fadeInUp',
			'fadeInUpBig',
			'fadeInDown',
			'fadeInDownBig',
			'fadeInLeft',
			'fadeInLeftBig',
			'fadeInRight',
			'fadeInRightBig',
			'fadeInTopLeft',
			'fadeInTopRight',
			'fadeInBottomLeft',
			'fadeInBottomRight',
			'rotateIn',
			'rotateInDownLeft',
			'rotateInDownRight',
			'rotateInUpLeft',
			'rotateInUpRight',
			'zoomIn',
			'bounce',
			'shake',
			'pulse',
			'flash',
			'tada',
			'slideInDown',
			'slideInLeft',
			'slideInRight',
			'slideInUp',
			'backInDown',
			'backInLeft',
			'backInRight',
			'backInUp',
			'flipInX',
			'flipInY',
			'lightSpeedInRight',
			'lightSpeedInLeft',
			'bounceInDown',
			'bounceInLeft',
			'bounceInRight',
			'bounceInUp',
			'rollIn'
		];

		function updateAnimatedElements() {
			$('.show-on-scroll').each(
				function() {
					var $element = $(this);

					if (!isInView($element)) {
						return;
					}

					if (
						$element.hasClass(
							'animateCustom-on-scroll'
						)
					) {
						$element.addClass(
							'animate-custom'
						);
					} else {
						var animationName =
							'fadeIn';

						animationNames.some(
							function(name) {
								if (
									$element.hasClass(
										name +
											'-on-scroll'
									)
								) {
									animationName =
										name;

									return true;
								}

								return false;
							}
						);

						$element.addClass(
							'animated ' +
								animationName +
								' animate__' +
								animationName
						);
					}

					if (
						$element.hasClass(
							'no-repeat'
						)
					) {
						$element.removeClass(
							'show-on-scroll'
						);
					}
				}
			);
		}

		function updatePageState() {
			framePending = false;

			var currentScroll =
				$window.scrollTop();

			var isScrolled =
				currentScroll > 100;

			var isDeepScrolled =
				currentScroll > 300;

			$body.toggleClass(
				'scrolled',
				isScrolled
			);

			$body.toggleClass(
				'scrolled-deeper',
				isDeepScrolled
			);

			$masthead.toggleClass(
				'sticky',
				isScrolled
			);

			$masthead.toggleClass(
				'deep-scroll',
				isDeepScrolled
			);

			if (contentStart !== null) {
				$body.toggleClass(
					'scrolled-content',
					currentScroll > contentStart
				);
			}

			updateAnimatedElements();
		}

		function schedulePageStateUpdate() {
			if (framePending) {
				return;
			}

			framePending = true;

			requestFrame(updatePageState);
		}

		function scrollToInitialAnchor() {
			var anchorId = window.location.hash
				? getAnchorIdFromHref(
					window.location.hash
				)
				: '';

			if (!anchorId) {
				var pathParts =
					window.location.pathname
						.split('/')
						.filter(function(part) {
							return part !== '';
						});

				anchorId = pathParts.length
					? safeDecodeURIComponent(
						pathParts[
							pathParts.length - 1
						]
					)
					: '';
			}

			var $target =
				getAnchorById(anchorId);

			if (
				!$target.length ||
				$target.hasClass('override-scroll')
			) {
				return;
			}

			var targetOffset =
				getNumericClassValue(
					$target,
					'scrollto',
					scrollOffset
				);

			var runScroll = function() {
				$('html, body')
					.stop(true)
					.animate({
						scrollTop: Math.max(
							0,
							$target.offset().top -
								targetOffset
						)
					}, 0, getScrollEasing());
			};

			if (
				/Chrome/.test(
					navigator.userAgent
				) &&
				/Google Inc/.test(
					navigator.vendor
				)
			) {
				window.setTimeout(
					runScroll,
					300
				);
			} else {
				runScroll();
			}
		}

		browserDetect($);
		accessibilityLinks($);
		comoMobileBehavior();
		checkNavMenu($);
		modalAdjustments($);

		if (
			$('#mainNav .update-url-on-scroll')
				.length
		) {
			registerScrollLinks($);
		}

		$('#nav-icon')
			.off('click.comoNavIcon')
			.on(
				'click.comoNavIcon',
				function() {
					$(this).toggleClass('open');
				}
			);

		$('.scroll-top, .home .scroll-top-home')
			.off('click.comoScrollTop')
			.on(
				'click.comoScrollTop',
				function(event) {
					event.preventDefault();

					$('html, body')
						.stop(true)
						.animate(
							{
								scrollTop: 0
							},
							800,
							getScrollEasing()
						);
				}
			);

		$body
			.off(
				'click.comoConfirm',
				'.confirm-link'
			)
			.on(
				'click.comoConfirm',
				'.confirm-link',
				function() {
					var message =
						$(this).data('msg') ||
						'You are about to leave this website. Please confirm to continue.';

					return window.confirm(
						message
					);
				}
			);

		$body
			.off(
				'click.comoScrollLink',
				'a.scroll-link, .scroll-link > a'
			)
			.on(
				'click.comoScrollLink',
				'a.scroll-link, .scroll-link > a',
				function(event) {
					event.preventDefault();

					scrollToAnchor(
						$(this),
						scrollOffset,
						scrollDelay
					);
				}
			);

		$('.navbar-collapse')
			.off(
				'click.comoCollapse',
				'li.scroll-link a'
			)
			.on(
				'click.comoCollapse',
				'li.scroll-link a',
				function() {
					var collapseElement =
						$(this).closest(
							'.navbar-collapse'
						)[0];

					if (
						collapseElement &&
						collapseElement.classList
							.contains('show') &&
						window.bootstrap &&
						window.bootstrap.Collapse
					) {
						var collapseInstance;

						if (
							typeof window.bootstrap
								.Collapse
								.getOrCreateInstance ===
							'function'
						) {
							collapseInstance =
								window.bootstrap
									.Collapse
									.getOrCreateInstance(
										collapseElement
									);
						} else {
							collapseInstance =
								new window.bootstrap
									.Collapse(
										collapseElement,
										{
											toggle: false
										}
									);
						}

						collapseInstance.hide();
					} else {
						$(
							'.navbar-toggle:visible, .navbar-toggler:visible'
						)
							.first()
							.trigger('click');
					}
				}
			);

		$('.search-toggle')
			.off('click.comoSearch')
			.on(
				'click.comoSearch',
				function(event) {
					event.preventDefault();

					$(this).toggleClass(
						'clicked'
					);

					$(this)
						.closest('.menu-search')
						.toggleClass('active');

					$(this)
						.parents('.widget')
						.toggleClass(
							'search-active'
						);
				}
			);

		$('#masthead .nav-link')
			.not('.search-toggle')
			.off('.comoSearchClose')
			.on(
				'mouseenter.comoSearchClose focus.comoSearchClose',
				function() {
					$masthead
						.find('.menu-search')
						.removeClass('active');

					$masthead
						.find('.search-active')
						.removeClass(
							'search-active'
						);
				}
			);

		$window
			.off('.comoPageState')
			.on(
				'scroll.comoPageState',
				schedulePageStateUpdate
			)
			.on(
				'resize.comoPageState',
				function() {
					comoMobileBehavior();

					contentStart =
						$contentWrap.length
							? $contentWrap
								.offset().top
							: null;

					schedulePageStateUpdate();
				}
			);

		scrollToInitialAnchor();
		schedulePageStateUpdate();
	});
})(jQuery);